import React from 'react';
import PropTypes from 'prop-types';

import './StepperList.scss';

interface StepperListProps {
 activeStep?: number;
 list?: unknown[];
}

/**
 * [propTypes description]
 * @type {Object}
 * @wxample
 * <StepperList list={[
 * 		{
 * 			title: "Step 1",
 * 			description: "Do this and that"
 * 		},
 * 		{
 * 			title: (<span style={{color: red}}>Step 2</span>),
 * 			description: (<div>Text with <a href="#">link</a>.</div>)
 * 		}
 * ]}/>
 * @wxample
 * // NOTE: the list manage done/active/inactive states itself as it may be bind to the content action (e.g. save button -> on success change states)
 * <StepperList
 * 	activeStep={2}
 * 	list={[
 * 		{
 * 			title: "Step 1",
 * 			className: 'step1Class',
 * 			description: "Do this and that",
 * 			finshed: true, // Mark the step finished independently on possition
 * 		},
 * 		{
 * 			title: (<span style={{color: red}}>Step 2</span>),
 * 			description: (<div>Text with <a href="#">link</a>.</div>),
 * 		}
 * ]} />
 */
export default class StepperList extends React.Component<StepperListProps> {
    static propTypes = {
        activeStep: PropTypes.number,
        list: PropTypes.array,
    }

    static defaultProps = {
        activeStep: 0
    }

    getClassForItem(item, idx) {
        let {activeStep} = this.props;
        let withActiveState = activeStep !== undefined;
        let activeClass = [];
        let isItemActive = idx === activeStep;

        if (item.finished) {
            activeClass.push('finished');
        }

        if (withActiveState) {
            if (isItemActive) {
                activeClass.push('active');
            }
            else if (idx < activeStep) {
                activeClass.push('done');
            }
            else {
                activeClass.push('inactive');
            }
        }

        return activeClass.join(' ');
    }

    render() {
        let list = [];
        let {activeStep} = this.props;
        let withActiveState = activeStep !== undefined;

        this.props.list.forEach((item, idx) => {
            let isItemActive = idx === activeStep;
            let activeClass = this.getClassForItem(item, idx);

            list.push((<dt className={activeClass + ' ' + (item.titleClass || '')} key={idx * 2}>{item.title}</dt>));

            if (item.description) {
                list.push((
                    <dd className={activeClass} key={idx * 2 + 1}>
                        <div className={"ddContent " + (item.className || '')}>
                            {withActiveState ? (isItemActive ? item.description : null) : item.description}
                        </div>
                    </dd>
                ));
            }
        });

        return (
            <dl className={"stepperList" + (withActiveState ? ' withActiveState' : '')}>
                {list}
            </dl>
        );
    }
}
